<div class="card title p-1">
    Chat with the Document
</div>
<div class="card">
    <div class="card-body p-2">
        <div *ngIf="questionAnswerHistory.length>0" class="card" for="qna-history">
            <div class="card-body">
                <div style="font-size:small" *ngFor="let qna of questionAnswerHistory">
                    <div style="text-align:left" for="question">
                        <strong>{{qna.question}}</strong>
                    </div>
                    <div style="text-align:right" for="answer">
                        {{qna.answer}}
                    </div>
                </div>
            </div>
        </div>
        <form #questionForm>
            <div class="input-group-sm mt-2 input-group col-12">
                <div class="input-group-prepend">
                    <span class="input-group-text">Question</span>
                </div>
                <textarea (keydown.enter)="questionAnwserHandler()" class="form-control" name="question"
                    [(ngModel)]="question">
                </textarea>
            </div>

            <div class="btn-group float-right m-2">
                <button class="btn" mat-stroked-button (click)="clearHandler()">
                    Clear
                </button>
                <button class="btn" type="submit" mat-stroked-button (click)="questionAnwserHandler()">
                    Send
                </button>
            </div>
        </form>
    </div>
</div>